import React from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import SignupForm from './SignupForm'
import LoginForm from './LoginForm'
import listensToClickOutside from 'react-onclickoutside'
import {
  closeLoginFormRequest,
  closeSignupFormRequest,
  openLoginFormRequest,
  openSignupFormRequest,
  doSignupUser,
  doLogoutUser,
  doFBLogin
} from '../actions'


@connect(
  state => (state), // Can be replaces by mapStateToProps function as well.
  {
    doSignupUser,
    doLogoutUser,
    doFBLogin,
    closeLoginFormRequest,
    closeSignupFormRequest,
    openLoginFormRequest,
    openSignupFormRequest
  }
)
class AuthFormModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
  }

  close = (e) => {
    this.props.closeLoginFormRequest()
    this.props.closeSignupFormRequest()
  }

  handleClickOutside = (event) => {
    this.close(event)
  }

  render() {
    let form = null
    let label = null
    let authModal = <span/>
    const {signup, location, authForm} = this.props
    let flow = ['/user/info']

    if (authForm) {
      if (authForm.payload.flow != null) {
        flow = authForm.payload.flow
      } else if (authForm.payload.next != null) {
        flow = [authForm.payload.next]
      }
    }

    const loginForm = (
      <div>
        <LoginForm signup={signup} payload={authForm.payload}/>
        <div className="authFormModal-signupFormWrapper" style={{textAlign: 'center'}}>
          <p> <Link onClick={this.close} to="/user/forgotpassword">Forgot your password?</Link> </p>
          <p> Don't have an account? </p>
          <button className="button button-default" onClick={(e) => {
            this.props.openSignupFormRequest({next: authForm.payload.next})
          }}>Sign up
          </button>
        </div>

      </div>
    )
    const signupForm = (
      <div>
        <SignupForm signup={signup}
                    flow={flow}
                    doSignupUser={this.props.doSignupUser}
                    doFBLogin={this.props.doFBLogin}
                    location={location}/>
        <div style={{textAlign: 'center', marginBottom: '4.0rem'}}>
          <p> Already have an account? </p>
          <button className="button button-default" onClick={(e) => {
            this.props.openLoginFormRequest({flow: authForm.payload.next})
          }}>Log in
          </button>
        </div>

      </div>
    )

    if (authForm.type) {
      if (authForm.type === 'signup') {
        form = signupForm
        label = 'Sign up'
      } else if (authForm.type === 'login') {
        form = loginForm
        label = 'Login'
      }

      authModal = (
        <div className="authModal">
          <div onClick={this.close} className="headBand">
            <i className="fa fa-angle-left"></i></div>
          {form}
        </div>
      )
    }

    return authModal
  }
}

export default (AuthFormModal)



// WEBPACK FOOTER //
// ./src/components/AuthFormsModal.jsx